// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const realTimeInventoryBundleUrl = "/api/sainc/owningCompaniesRealTimeInventory/bundle";
const realTimeInventorySingleUrl = "/api/sainc/owningCompaniesRealTimeInventory/product";

export interface RealTimeInventoryModel {
    components?: BundleElement[];
    bundleErpNumber?: string;
    productNumber?: string;
    successful?: boolean;
    result?: any;
    errorMessage?: any;
}
export interface BundleElement {
    erpNumber: string;
    qtyPer: number;
}

export interface RealTimeInventoryParameter extends ApiParameter {
    inventory?: Partial<RealTimeInventoryModel>;
}

export async function getInventoryForBundleProduct(
    parameter: RealTimeInventoryParameter,
): Promise<ServiceResult<RealTimeInventoryModel>> {
    try {
        const inventory = await post<RealTimeInventoryModel>(
            `${realTimeInventoryBundleUrl}`,
            parameter.inventory as RealTimeInventoryModel,
        );
        return {
            result: inventory,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}

export async function getInventoryForSingleProduct(
    parameter: RealTimeInventoryParameter,
): Promise<ServiceResult<RealTimeInventoryModel>> {
    try {
        const inventory = await post<RealTimeInventoryModel>(
            `${realTimeInventorySingleUrl}`,
            parameter.inventory as RealTimeInventoryModel,
        );
        return {
            result: inventory,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
